module.exports = __webpack_public_path__ + "static/panoramicImage-3e2915180a5409e9c79191bb7f50a063.png";